import React from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";

const CustomerTableSection = ({
	filteredItems,
	isLoading,
	updateCounter,
	isEditMode,
	selectedSerialAmount,
	setSelectedSerialAmount,
}) => {
	const renderBlockDisplay = (rowData) => {
		const blockName = rowData.unique?.block?.name;

		if (blockName) {
			return (
				<span className="px-3 py-1 text-sm text-green-700 bg-green-100 rounded-md">
					{blockName}
				</span>
			);
		} else {
			return (
				<span className="px-3 py-1 text-sm text-red-700 bg-red-100 rounded-md">
					Блок танланмаган
				</span>
			);
		}
	};

	const renderQuantityInput = (rowData) => (
		<InputText
			className="w-20 py-2 pl-2 border"
			max={rowData.amount}
			onChange={(e) => setSelectedSerialAmount(e.value)}
			value={selectedSerialAmount}
			type="number"
			min="0"
		/>
	);

	const renderItemName = (rowData) => {
		return rowData.unique?.name || `ITEM-${rowData.id}`;
	};

	const renderFurnitureName = (rowData) => {
		if (isEditMode) {
			return (
				rowData.furniture?.name ||
				rowData.demand_furniture?.furniture?.name ||
				"N/A"
			);
		}
		return (
			`${rowData.furniture?.komplekt_furniture?.[0]?.komplekt?.name || ""} ${
				rowData.furniture?.category_furniture?.name || ""
			} ${rowData.furniture?.name || ""}`.trim() || "N/A"
		);
	};

	const renderOrderQuantity = (rowData) => {
		return rowData.amount || 0;
	};

	const renderFromWhere = (rowData) => (
		<span className="px-3 py-1 text-sm text-blue-700 bg-blue-100 rounded-md">
			{rowData.fromWhere || `SKLAD`}
		</span>
	);

	return (
		<DataTable
			className="custom-row-border"
			value={filteredItems}
			loading={isLoading}
			key={`main-table-${updateCounter}`}
			emptyMessage="Маълумотлар топилмади">
			<Column className="min-w-[150px]" header="#" body={renderItemName} />
			<Column
				className="min-w-[150px]"
				header="МЕБЕЛ"
				body={renderFurnitureName}
			/>
			<Column
				className="min-w-[150px]"
				header="ЗАКАЗ К-ВО"
				body={renderOrderQuantity}
			/>
			<Column
				className="min-w-[150px]"
				header="К-ВО"
				body={renderQuantityInput}
			/>
			<Column
				className="min-w-[175px]"
				header="Қаердан"
				body={renderFromWhere}
			/>
			<Column
				className="min-w-[150px]"
				header="БЛОК"
				body={renderBlockDisplay}
			/>
		</DataTable>
	);
};

export default CustomerTableSection;
